import { ViewPdf } from "./ViewPdf";
import { useMultiplePdfs } from "./useMultiplePdfs";
import { SecDocument } from "../../types";
import React from "react";
import { Col, Row, Button } from "reactstrap";

interface DisplayMultiplePdfsProps {
  pdfs: SecDocument[];
}

export const DisplayMultiplePdfs: React.FC<DisplayMultiplePdfsProps> = ({
  pdfs,
}) => {
  const { isActivePdf, handlePdfFocus } = useMultiplePdfs(pdfs);

  return (
    <>
      <div className="flex h-100 items-start justify-center">
        <Row className="m-0 h-100 w-100">
          <Col className="p-0 d-flex flex-column h-100" md={10}>
            {/* <h5>{}</h5> */}
            {pdfs.map(
              (file) =>
                isActivePdf(file) && (
                  <div
                    key={`viewing-${file.url}`}
                    className="h-100 flex-grow overflow-y-auto"
                  >
                    <ViewPdf file={file} />
                  </div>
                )
            )}
          </Col>
          <Col className="p-0 d-flex flex-column h-100" md={2} style={{ overflowY: 'auto' }}>
            <div className="flex flex-col h-100 border-l bg-gray-100">
              {pdfs.map((file, index) => (
                <Button
                key={index}
                onClick={() => handlePdfFocus(file)}
                className={`flex items-center justify-start px-2 py-1 text-left font-nunito text-sm hover:bg-gray-200 ${
                  isActivePdf(file)
                    ? "bg-gray-300 font-bold"
                    : "font-light text-gray-600"
                }`}
                style={{
                  wordBreak: "break-word",
                  borderBottom: "5px solid #ccc", // Add a bottom border for separation
                }}
              >
                {file.identifierName}
              </Button>
              ))}
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default DisplayMultiplePdfs;

